import { TERM_BUNDLE, type TermsFactory } from '@commons/pagebuilder/terms';

import InsightTopicTerm from './InsightTopic';

/**
 * Enum of all available term bundles for AiiA.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum AIIA_TERM_BUNDLE {}

/**
 * Factory of all available terms for AiiA.
 */

export const aiiaTerms: TermsFactory = {
  [TERM_BUNDLE.InsightTopic]: InsightTopicTerm,
};
